// Taxonomie Partenaires (trilingue FR/NL/EN) — Incrément 1 Lot 1
export const pl = (lang, e) => (e && (e[lang] || e.fr)) || "";

export const PARTNER_CATEGORIES = {
  medical: { fr: "Médical", en: "Medical", nl: "Medisch", color: "#f43f5e" },
  institutionnel: { fr: "Institutionnel", en: "Institutional", nl: "Institutioneel", color: "#3b82f6" },
  associatif: { fr: "Associatif", en: "Community / Non-profit", nl: "Verenigingsleven", color: "#10b981" },
};

export const PARTNER_SUBCATEGORIES = {
  medical: [
    { k: "hopital", fr: "Hôpital", en: "Hospital", nl: "Ziekenhuis" },
    { k: "clinique", fr: "Clinique", en: "Clinic", nl: "Kliniek" },
    { k: "service_social_hospitalier", fr: "Service social hospitalier", en: "Hospital social service", nl: "Sociale dienst ziekenhuis" },
    { k: "medecin_generaliste", fr: "Médecin généraliste", en: "General practitioner", nl: "Huisarts" },
    { k: "geriatre", fr: "Gériatre", en: "Geriatrician", nl: "Geriater" },
    { k: "medecin_specialiste", fr: "Médecin spécialiste", en: "Specialist doctor", nl: "Specialist" },
    { k: "maison_medicale", fr: "Maison médicale", en: "Medical center", nl: "Wijkgezondheidscentrum" },
    { k: "infirmier_domicile", fr: "Infirmier(ère) à domicile", en: "Home nurse", nl: "Thuisverpleegkundige" },
    { k: "kine", fr: "Kinésithérapeute", en: "Physiotherapist", nl: "Kinesitherapeut" },
    { k: "psychologue", fr: "Psychologue", en: "Psychologist", nl: "Psycholoog" },
    { k: "pharmacie", fr: "Pharmacie", en: "Pharmacy", nl: "Apotheek" },
    { k: "centre_revalidation", fr: "Centre de revalidation", en: "Rehabilitation center", nl: "Revalidatiecentrum" },
    { k: "equipe_demence", fr: "Équipe spécialisée en démence", en: "Dementia specialist team", nl: "Dementie-expertiseteam" },
    { k: "coordination_medicale", fr: "Coordination médicale ou paramédicale", en: "Medical/paramedical coordination", nl: "Medische/paramedische coördinatie" },
    { k: "autre_medical", fr: "Autre acteur médical", en: "Other medical actor", nl: "Andere medische actor" },
  ],
  institutionnel: [
    { k: "cpas", fr: "CPAS", en: "Public social welfare (CPAS)", nl: "OCMW" },
    { k: "commune_admin", fr: "Commune ou administration", en: "Municipality / administration", nl: "Gemeente of administratie" },
    { k: "service_social", fr: "Service social", en: "Social service", nl: "Sociale dienst" },
    { k: "mutualite", fr: "Mutualité", en: "Health insurance fund", nl: "Ziekenfonds" },
    { k: "coordination_soins", fr: "Coordination de soins", en: "Care coordination", nl: "Zorgcoördinatie" },
    { k: "aide_soins_domicile", fr: "Service d'aide et de soins à domicile", en: "Home care service", nl: "Thuiszorgdienst" },
    { k: "administrateur_biens", fr: "Administrateur de biens ou mandataire", en: "Property administrator / agent", nl: "Bewindvoerder of gemachtigde" },
    { k: "notaire", fr: "Notaire", en: "Notary", nl: "Notaris" },
    { k: "accompagnement_ages", fr: "Service d'accompagnement des personnes âgées", en: "Elderly support service", nl: "Begeleidingsdienst ouderen" },
    { k: "organisme_logement", fr: "Organisme de logement", en: "Housing agency", nl: "Huisvestingsorganisatie" },
    { k: "autre_institutionnel", fr: "Autre acteur institutionnel", en: "Other institutional actor", nl: "Andere institutionele actor" },
  ],
  associatif: [
    { k: "association_seniors", fr: "Association de seniors", en: "Seniors association", nl: "Seniorenvereniging" },
    { k: "association_aidants", fr: "Association d'aidants proches", en: "Family caregivers association", nl: "Mantelzorgvereniging" },
    { k: "association_demence", fr: "Association liée à la démence", en: "Dementia association", nl: "Dementievereniging" },
    { k: "asbl", fr: "ASBL", en: "Non-profit (ASBL)", nl: "VZW" },
    { k: "club_loisirs", fr: "Club ou loisirs", en: "Club / leisure", nl: "Club of vrije tijd" },
    { k: "association_quartier", fr: "Association de quartier", en: "Neighborhood association", nl: "Buurtvereniging" },
    { k: "paroisse_communaute", fr: "Paroisse ou communauté", en: "Parish / community", nl: "Parochie of gemeenschap" },
    { k: "reseau_benevoles", fr: "Réseau de bénévoles", en: "Volunteer network", nl: "Vrijwilligersnetwerk" },
    { k: "club_service", fr: "Rotary, Lions ou club de services", en: "Rotary, Lions or service club", nl: "Rotary, Lions of serviceclub" },
    { k: "association_intergen", fr: "Association intergénérationnelle", en: "Intergenerational association", nl: "Intergenerationele vereniging" },
    { k: "autre_associatif", fr: "Autre acteur associatif", en: "Other community actor", nl: "Andere verenigingsactor" },
  ],
};

export const PARTNER_STATUSES = [
  { k: "a_identifier", fr: "À identifier", en: "To identify", nl: "Te identificeren", color: "#94a3b8" },
  { k: "a_contacter", fr: "À contacter", en: "To contact", nl: "Te contacteren", color: "#64748b" },
  { k: "premier_contact", fr: "Premier contact réalisé", en: "First contact made", nl: "Eerste contact gelegd", color: "#0ea5e9" },
  { k: "rdv_propose", fr: "Rendez-vous proposé", en: "Meeting proposed", nl: "Afspraak voorgesteld", color: "#6366f1" },
  { k: "rdv_planifie", fr: "Rendez-vous planifié", en: "Meeting scheduled", nl: "Afspraak gepland", color: "#8b5cf6" },
  { k: "rdv_realise", fr: "Rendez-vous réalisé", en: "Meeting done", nl: "Afspraak uitgevoerd", color: "#a855f7" },
  { k: "infos_envoyees", fr: "Informations envoyées", en: "Information sent", nl: "Informatie verzonden", color: "#d946ef" },
  { k: "visite_proposee", fr: "Visite proposée", en: "Visit proposed", nl: "Bezoek voorgesteld", color: "#ec4899" },
  { k: "visite_realisee", fr: "Visite réalisée", en: "Visit done", nl: "Bezoek uitgevoerd", color: "#f59e0b" },
  { k: "actif", fr: "Partenaire actif", en: "Active partner", nl: "Actieve partner", color: "#10b981" },
  { k: "ambassadeur", fr: "Partenaire ambassadeur", en: "Ambassador partner", nl: "Ambassadeur-partner", color: "#059669" },
  { k: "a_relancer", fr: "À relancer", en: "To follow up", nl: "Op te volgen", color: "#f97316" },
  { k: "sans_reponse", fr: "Sans réponse", en: "No response", nl: "Geen antwoord", color: "#ef4444" },
  { k: "non_prioritaire", fr: "Non prioritaire", en: "Not a priority", nl: "Geen prioriteit", color: "#6b7280" },
  { k: "suspendu", fr: "Relation suspendue", en: "Relationship suspended", nl: "Relatie opgeschort", color: "#b91c1c" },
];

export const PARTNER_PRIORITIES = {
  A: { fr: "Priorité A", en: "Priority A", nl: "Prioriteit A", color: "#ef4444" },
  B: { fr: "Priorité B", en: "Priority B", nl: "Prioriteit B", color: "#f59e0b" },
  C: { fr: "Priorité C", en: "Priority C", nl: "Prioriteit C", color: "#10b981" },
};

export const PARTNER_INTERACTION_TYPES = [
  { k: "appel_entrant", fr: "Appel entrant", en: "Incoming call", nl: "Inkomend gesprek" },
  { k: "appel_sortant", fr: "Appel sortant", en: "Outgoing call", nl: "Uitgaand gesprek" },
  { k: "email_recu", fr: "E-mail reçu", en: "Email received", nl: "E-mail ontvangen" },
  { k: "email_envoye", fr: "E-mail envoyé", en: "Email sent", nl: "E-mail verzonden" },
  { k: "rdv_externe", fr: "Rendez-vous externe", en: "External meeting", nl: "Externe afspraak" },
  { k: "rdv_residence", fr: "Rendez-vous dans la résidence", en: "Meeting at the residence", nl: "Afspraak in de residentie" },
  { k: "visite_residence", fr: "Visite de la résidence", en: "Residence visit", nl: "Bezoek residentie" },
  { k: "reunion", fr: "Réunion", en: "Meeting", nl: "Vergadering" },
  { k: "evenement", fr: "Événement", en: "Event", nl: "Evenement" },
  { k: "newsletter", fr: "Newsletter ou campagne", en: "Newsletter / campaign", nl: "Nieuwsbrief of campagne" },
  { k: "demande_transmise", fr: "Demande transmise", en: "Referral submitted", nl: "Aanvraag doorgegeven" },
  { k: "autre", fr: "Autre", en: "Other", nl: "Andere" },
];

export const PARTNER_ACTION_TYPES = [
  { k: "rappeler", fr: "Rappeler", en: "Call back", nl: "Terugbellen" },
  { k: "envoyer_email", fr: "Envoyer un e-mail", en: "Send an email", nl: "E-mail sturen" },
  { k: "envoyer_infos", fr: "Envoyer des informations", en: "Send information", nl: "Informatie sturen" },
  { k: "planifier_rdv", fr: "Planifier un rendez-vous", en: "Schedule a meeting", nl: "Afspraak plannen" },
  { k: "planifier_visite", fr: "Planifier une visite", en: "Schedule a visit", nl: "Bezoek plannen" },
  { k: "relancer", fr: "Relancer", en: "Follow up", nl: "Opvolgen" },
  { k: "autre", fr: "Autre action", en: "Other action", nl: "Andere actie" },
];

export const PARTNER_LANGS = { fr: "Français", nl: "Nederlands", en: "English" };
export const PARTNER_POTENTIAL = { fort: { fr: "Fort", en: "High", nl: "Hoog" }, moyen: { fr: "Moyen", en: "Medium", nl: "Gemiddeld" }, faible: { fr: "Faible", en: "Low", nl: "Laag" } };
export const PARTNER_FREQ = { hebdo: { fr: "Hebdomadaire", en: "Weekly", nl: "Wekelijks" }, mensuel: { fr: "Mensuelle", en: "Monthly", nl: "Maandelijks" }, trimestriel: { fr: "Trimestrielle", en: "Quarterly", nl: "Per kwartaal" }, rare: { fr: "Rare", en: "Rare", nl: "Zelden" } };

export const statusEntry = (k) => PARTNER_STATUSES.find((s) => s.k === k);
export const subcatEntry = (cat, k) => (PARTNER_SUBCATEGORIES[cat] || []).find((s) => s.k === k);
export const interactionEntry = (k) => PARTNER_INTERACTION_TYPES.find((s) => s.k === k);

export const PROSPECT_SOURCES = [
  { k: "famille_directe", fr: "Famille directe", en: "Direct family", nl: "Directe familie" },
  { k: "site_novadia", fr: "Site Novadia", en: "Novadia website", nl: "Novadia-website" },
  { k: "carepilot", fr: "CarePilot", en: "CarePilot", nl: "CarePilot" },
  { k: "cpas", fr: "CPAS", en: "CPAS (public welfare)", nl: "OCMW" },
  { k: "hopital", fr: "Hôpital", en: "Hospital", nl: "Ziekenhuis" },
  { k: "assistant_social", fr: "Assistant social", en: "Social worker", nl: "Maatschappelijk werker" },
  { k: "medecin", fr: "Médecin", en: "Doctor", nl: "Arts" },
  { k: "infirmier", fr: "Infirmier", en: "Nurse", nl: "Verpleegkundige" },
  { k: "pharmacie", fr: "Pharmacie", en: "Pharmacy", nl: "Apotheek" },
  { k: "mutualite", fr: "Mutualité", en: "Health insurance fund", nl: "Ziekenfonds" },
  { k: "association", fr: "Association", en: "Association", nl: "Vereniging" },
  { k: "evenement", fr: "Événement", en: "Event", nl: "Evenement" },
  { k: "bouche_a_oreille", fr: "Bouche-à-oreille", en: "Word of mouth", nl: "Mond-tot-mond" },
  { k: "retraite_plus", fr: "Retraite Plus", en: "Retraite Plus", nl: "Retraite Plus" },
  { k: "autre_plateforme", fr: "Autre plateforme", en: "Other platform", nl: "Ander platform" },
  { k: "autre_residence", fr: "Autre résidence du Groupe", en: "Other Group residence", nl: "Andere residentie van de Groep" },
  { k: "autre", fr: "Autre", en: "Other", nl: "Andere" },
];

export const PROSPECT_FINAL_RESULT = [
  { k: "en_cours", fr: "En cours", en: "In progress", nl: "Lopend" },
  { k: "visite_realisee", fr: "Visite réalisée", en: "Visit done", nl: "Bezoek uitgevoerd" },
  { k: "admission_confirmee", fr: "Admission confirmée", en: "Admission confirmed", nl: "Opname bevestigd" },
  { k: "refus_famille", fr: "Refus famille", en: "Family declined", nl: "Familie weigerde" },
  { k: "non_adapte", fr: "Non adapté", en: "Not suitable", nl: "Niet geschikt" },
  { k: "perdu", fr: "Perdu / sans réponse", en: "Lost / no response", nl: "Verloren / geen antwoord" },
];

export const sourceEntry = (k) => PROSPECT_SOURCES.find((s) => s.k === k);
export const actionEntry = (k) => PARTNER_ACTION_TYPES.find((s) => s.k === k);

// ---------------- Événements (Lot 2) ----------------
export const EVENT_TYPES = [
  { k: "portes_ouvertes", fr: "Portes ouvertes", en: "Open house", nl: "Opendeurdag" },
  { k: "conference", fr: "Conférence", en: "Conference", nl: "Conferentie" },
  { k: "petit_dejeuner", fr: "Petit-déjeuner partenaires", en: "Partner breakfast", nl: "Partnerontbijt" },
  { k: "dejeuner", fr: "Déjeuner partenaires", en: "Partner lunch", nl: "Partnerlunch" },
  { k: "salon", fr: "Salon", en: "Trade show", nl: "Beurs" },
  { k: "reunion_pro", fr: "Réunion professionnelle", en: "Professional meeting", nl: "Professionele vergadering" },
  { k: "visite_collective", fr: "Visite collective", en: "Group visit", nl: "Collectief bezoek" },
  { k: "evenement_associatif", fr: "Événement associatif", en: "Community event", nl: "Verenigingsevenement" },
  { k: "atelier", fr: "Atelier", en: "Workshop", nl: "Workshop" },
  { k: "relations_publiques", fr: "Action de relations publiques", en: "Public relations action", nl: "PR-actie" },
  { k: "interne_ouvert", fr: "Événement interne ouvert au public", en: "Internal event open to public", nl: "Intern evenement open voor publiek" },
  { k: "autre", fr: "Autre", en: "Other", nl: "Andere" },
];

export const EVENT_STATUSES = [
  { k: "brouillon", fr: "Brouillon", en: "Draft", nl: "Concept", color: "#94a3b8" },
  { k: "planifie", fr: "Planifié", en: "Planned", nl: "Gepland", color: "#3b82f6" },
  { k: "invitations", fr: "Invitations en cours", en: "Invitations in progress", nl: "Uitnodigingen lopende", color: "#8b5cf6" },
  { k: "confirme", fr: "Confirmé", en: "Confirmed", nl: "Bevestigd", color: "#0ea5e9" },
  { k: "realise", fr: "Réalisé", en: "Completed", nl: "Uitgevoerd", color: "#10b981" },
  { k: "annule", fr: "Annulé", en: "Cancelled", nl: "Geannuleerd", color: "#ef4444" },
  { k: "reporte", fr: "Reporté", en: "Postponed", nl: "Uitgesteld", color: "#f59e0b" },
];

export const GUEST_KINDS = [
  { k: "partner", fr: "Partenaire", en: "Partner", nl: "Partner" },
  { k: "prospect", fr: "Prospect", en: "Prospect", nl: "Prospect" },
  { k: "family", fr: "Famille", en: "Family", nl: "Familie" },
  { k: "contact", fr: "Nouveau contact", en: "New contact", nl: "Nieuw contact" },
];

export const GUEST_RESPONSES = [
  { k: "pending", fr: "En attente", en: "Pending", nl: "In afwachting", color: "#94a3b8" },
  { k: "accepted", fr: "Confirmé", en: "Accepted", nl: "Bevestigd", color: "#10b981" },
  { k: "tentative", fr: "Peut-être", en: "Tentative", nl: "Misschien", color: "#f59e0b" },
  { k: "declined", fr: "Décliné", en: "Declined", nl: "Afgewezen", color: "#ef4444" },
];

export const eventTypeEntry = (k) => EVENT_TYPES.find((s) => s.k === k);
export const eventStatusEntry = (k) => EVENT_STATUSES.find((s) => s.k === k);
export const guestKindEntry = (k) => GUEST_KINDS.find((s) => s.k === k);
export const guestResponseEntry = (k) => GUEST_RESPONSES.find((s) => s.k === k);

// ---------------- Satisfaction partenaire (Lot 2 · Incrément B) ----------------
export const SAT_CONTEXTS = [
  { k: "apres_rdv", fr: "Après rendez-vous", en: "After meeting", nl: "Na afspraak" },
  { k: "apres_demande", fr: "Après demande transmise", en: "After referral", nl: "Na aanvraag" },
  { k: "apres_admission", fr: "Après admission", en: "After admission", nl: "Na opname" },
  { k: "apres_evenement", fr: "Après événement", en: "After event", nl: "Na evenement" },
  { k: "bilan_periodique", fr: "Bilan périodique", en: "Periodic review", nl: "Periodieke evaluatie" },
];

export const SAT_QUESTIONS = [
  { k: "q_speed", fr: "Rapidité de réponse", en: "Response speed", nl: "Reactiesnelheid" },
  { k: "q_welcome", fr: "Qualité de l'accueil", en: "Quality of welcome", nl: "Kwaliteit onthaal" },
  { k: "q_clarity", fr: "Clarté des informations", en: "Clarity of information", nl: "Duidelijkheid informatie" },
  { k: "q_ease_request", fr: "Facilité de transmission d'une demande", en: "Ease of submitting a request", nl: "Gemak aanvraag" },
  { k: "q_followup", fr: "Qualité du suivi", en: "Quality of follow-up", nl: "Kwaliteit opvolging" },
  { k: "q_availability", fr: "Disponibilité de l'équipe", en: "Team availability", nl: "Beschikbaarheid team" },
  { k: "q_general", fr: "Satisfaction générale", en: "Overall satisfaction", nl: "Algemene tevredenheid" },
  { k: "q_recommend", fr: "Probabilité de recommander", en: "Likelihood to recommend", nl: "Aanbevelingskans" },
];

export const satContextEntry = (k) => SAT_CONTEXTS.find((s) => s.k === k);

// ---------------- Partenariats associatifs (Lot 2 · Incrément C) ----------------
export const PARTNERSHIP_TYPES = [
  { k: "convention", fr: "Convention", en: "Agreement", nl: "Overeenkomst" },
  { k: "mise_a_disposition_local", fr: "Mise à disposition de local", en: "Premises provided", nl: "Terbeschikkingstelling lokaal" },
  { k: "benevolat", fr: "Bénévolat", en: "Volunteering", nl: "Vrijwilligerswerk" },
  { k: "evenementiel", fr: "Événementiel", en: "Events", nl: "Evenementen" },
  { k: "parrainage", fr: "Parrainage", en: "Sponsorship", nl: "Peterschap" },
  { k: "echange_services", fr: "Échange de services", en: "Service exchange", nl: "Dienstenruil" },
  { k: "autre", fr: "Autre", en: "Other", nl: "Andere" },
];

export const PARTNERSHIP_STATUSES = [
  { k: "proposition", fr: "Proposition", en: "Proposal", nl: "Voorstel", color: "#94a3b8" },
  { k: "en_discussion", fr: "En discussion", en: "In discussion", nl: "In bespreking", color: "#3b82f6" },
  { k: "a_valider", fr: "À valider", en: "To validate", nl: "Te valideren", color: "#8b5cf6" },
  { k: "convention_a_signer", fr: "Convention à signer", en: "Agreement to sign", nl: "Overeenkomst te tekenen", color: "#f59e0b" },
  { k: "actif", fr: "Actif", en: "Active", nl: "Actief", color: "#10b981" },
  { k: "a_renouveler", fr: "À renouveler", en: "To renew", nl: "Te vernieuwen", color: "#f97316" },
  { k: "suspendu", fr: "Suspendu", en: "Suspended", nl: "Opgeschort", color: "#ef4444" },
  { k: "termine", fr: "Terminé", en: "Ended", nl: "Beëindigd", color: "#6b7280" },
];

export const PARTNERSHIP_RENEWAL = [
  { k: "tacite", fr: "Tacite", en: "Automatic", nl: "Stilzwijgend" },
  { k: "expresse", fr: "Expresse", en: "Express", nl: "Uitdrukkelijk" },
  { k: "non", fr: "Sans renouvellement", en: "No renewal", nl: "Geen vernieuwing" },
];

export const partnershipTypeEntry = (k) => PARTNERSHIP_TYPES.find((s) => s.k === k);
export const partnershipStatusEntry = (k) => PARTNERSHIP_STATUSES.find((s) => s.k === k);

// ---------------- Communication (Lot 3) ----------------
export const COMM_TEMPLATE_TYPES = [
  { k: "newsletter", fr: "Newsletter", en: "Newsletter", nl: "Nieuwsbrief" },
  { k: "invitation", fr: "Invitation", en: "Invitation", nl: "Uitnodiging" },
  { k: "relance", fr: "Relance", en: "Follow-up", nl: "Herinnering" },
  { k: "remerciement", fr: "Remerciement", en: "Thank you", nl: "Bedanking" },
  { k: "voeux", fr: "Vœux", en: "Greetings", nl: "Wensen" },
  { k: "presentation_residence", fr: "Présentation d'une résidence", en: "Residence presentation", nl: "Voorstelling residentie" },
  { k: "disponibilites", fr: "Information disponibilités", en: "Availability info", nl: "Beschikbaarheidsinfo" },
];

export const SMART_SEGMENTS = [
  { k: "ambassadors", fr: "Partenaires ambassadeurs", en: "Ambassador partners", nl: "Ambassadeur-partners" },
  { k: "inactive_30", fr: "Inactifs depuis 30 j", en: "Inactive 30+ days", nl: "Inactief 30+ dagen" },
  { k: "inactive_60", fr: "Inactifs depuis 60 j", en: "Inactive 60+ days", nl: "Inactief 60+ dagen" },
  { k: "inactive_90", fr: "Inactifs depuis 90 j", en: "Inactive 90+ days", nl: "Inactief 90+ dagen" },
  { k: "unsatisfied", fr: "Partenaires insatisfaits", en: "Unsatisfied partners", nl: "Ontevreden partners" },
  { k: "new", fr: "Nouveaux partenaires", en: "New partners", nl: "Nieuwe partners" },
  { k: "high_potential", fr: "Fort potentiel", en: "High potential", nl: "Hoog potentieel" },
  { k: "never_referred", fr: "N'ayant jamais orienté", en: "Never referred", nl: "Nooit doorverwezen" },
  { k: "recent_request", fr: "Demande récente", en: "Recent request", nl: "Recente aanvraag" },
];

export const commTemplateEntry = (k) => COMM_TEMPLATE_TYPES.find((s) => s.k === k);

export const AUTOMATION_TRIGGERS = [
  { k: "relance_inactivity", fr: "Relance après inactivité", en: "Follow-up after inactivity", nl: "Herinnering na inactiviteit" },
  { k: "remerciement_orientation", fr: "Remerciement après orientation", en: "Thanks after referral", nl: "Bedanking na doorverwijzing" },
  { k: "voeux_annuels", fr: "Vœux annuels", en: "Annual greetings", nl: "Jaarlijkse wensen" },
  { k: "rappel_visite", fr: "Rappel avant visite/événement", en: "Reminder before visit/event", nl: "Herinnering vóór bezoek/evenement" },
  { k: "relance_sans_clic", fr: "Relance après campagne sans clic", en: "Follow-up after no-click campaign", nl: "Herinnering na campagne zonder klik" },
];
export const automationTriggerEntry = (k) => AUTOMATION_TRIGGERS.find((s) => s.k === k);
